import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import { useMigrateBanner } from "@/composables/useMigrateBanner";
import WeProposeOurAppModal from "@/components/modals/WeProposeOurAppModal.vue";
import { isIOSdevice } from "@/utils/deviceType.util";


export default /*#__PURE__*/_defineComponent({
  __name: 'MigrateBanner',
  setup(__props, { expose }) {
  expose();

const { isMigratedToApp, showMigrateBanner } = useMigrateBanner();
const isOpenWeProposeModal = ref<boolean>(false);

const destinationLink = ref<string>(
  isIOSdevice.value
    ? "https://apps.apple.com/us/app/erf-clubhouse/id6526485959"
    : "https://play.google.com/store/apps/details?id=com.clubhouse.clubhouse_client"
);

const __returned__ = { isMigratedToApp, showMigrateBanner, isOpenWeProposeModal, destinationLink, ref, useMigrateBanner, WeProposeOurAppModal, isIOSdevice }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})